import Intersection from "./scripts/components/intersection";
import './scripts/modal';

document.addEventListener("DOMContentLoaded", () => {
  const intersection = new Intersection(".animate", (entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("animated");
    }
  });
  const countdown = new Intersection("[data-chart]", (entry) => {
    if (entry.isIntersecting) {
      const targetData = entry.target.dataset.chart;
      entry.target.style.setProperty("--num", targetData);
    }
  });
  const load = new Intersection("[data-load]", (entry) => {
    if (entry.isIntersecting && !entry.target.classList.contains("loaded")) {
      const targetSVG = entry.target.dataset.load;
      fetch(`${window.urls.template}/dist/svg/${targetSVG}`)
        .then((res) => res.text())
        .then((data) => {
          entry.target.innerHTML = data;
          setTimeout(() => {
            entry.target.classList.add("loaded");
          }, 100);
        });
    }
  });

});
